import React, { PropsWithChildren } from 'react'
import { Button } from '@/atoms/Button'

interface AudienceInterestProps {
  buttonText: string
  onButtonClick: () => void
}

const AudienceInterestGlow = ({
  width,
  height,
  left,
  top,
  transform,
  mobileTransform,
  radialColor,
}: {
  width: number
  height: number
  left: string
  top: string
  transform: string
  mobileTransform: string
  radialColor: string
}) => (
  <>
    <div
      className="absolute hidden lg:block"
      style={{
        width,
        height,
        left,
        top,
        transform,
        borderRadius: `${width}px`,
        background: `radial-gradient(42% 41% at 51% 50%, ${radialColor} 0%, rgba(242, 159, 61, 0.00) 100%)`,
      }}
    />
    <div
      className="absolute block lg:hidden"
      style={{
        width,
        height,
        left,
        top,
        transform: mobileTransform,
        borderRadius: `${width}px`,
        background: `radial-gradient(42% 41% at 51% 50%, ${radialColor} 0%, rgba(242, 159, 61, 0.00) 100%)`,
      }}
    />
  </>
)

export const AudienceInterest = ({ children, buttonText, onButtonClick }: PropsWithChildren<AudienceInterestProps>) => {
  return (
    <div
      className={`relative mx-auto w-5/6 max-w-screen-lg overflow-hidden rounded-lg bg-[linear-gradient(to_bottom_right,#EDD7C6,#D6A177,#FEDEC6,#D48D59,#A66141,#612B12)] p-[2px]`}
    >
      <div className="rounded-lg bg-black px-[5%] py-6">
        <div className="z-30 flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center lg:gap-4">
          {children}
          <div className="flex grow-1 justify-start lg:justify-end">
            <Button className="z-30" variant="white" onClick={onButtonClick}>
              {buttonText}
            </Button>
          </div>
          <div className="absolute inset-0 z-10">
            <AudienceInterestGlow
              width={646}
              height={477}
              left="50%"
              top="50%"
              transform="rotate(-174deg) translate(10%, 50%)"
              mobileTransform="rotate(-174deg) translate(20%, 50%)"
              radialColor="rgba(242, 159, 61, 0.20)"
            />
            <AudienceInterestGlow
              width={988}
              height={495}
              left="10%"
              top="50%"
              transform="rotate(-174deg) translate(0, 50%)"
              mobileTransform="rotate(-174deg) translate(20%, 30%)"
              radialColor="rgba(0, 164, 191, 0.20)"
            />
            <AudienceInterestGlow
              width={875}
              height={418}
              left="60%"
              top="40%"
              transform="rotate(-174deg) translate(0, 50%)"
              mobileTransform="rotate(-174deg) translate(00%, 20%)"
              radialColor="rgba(244, 90, 59, 0.20)"
            />
            <AudienceInterestGlow
              width={1400}
              height={856}
              left="-60%"
              top="30%"
              transform="rotate(-174deg) translate(0, 50%)"
              mobileTransform="rotate(-174deg) translate(40%, 30%)"
              radialColor="rgba(33, 206, 160, 0.10)"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
